<template lang="">
    <div>
        <b-dropdown 
            variant="link" 
            toggle-class="dropdown text-decoration-none" 
            no-caret>
                <template v-slot:button-content>
                    <a id="iconFlag"><i class="ico-flag-br flag-icon"></i></a>
                </template>
                <b-dropdown-item 
                    href="#" 
                    v-on:click.prevent="changeSelectedFlag('pt-BR')"
                    v-show="this.$store.state.active_BR"
                    >
                        <i class="ico-flag-br flag-icon"></i>
                </b-dropdown-item>
                <b-dropdown-item 
                    href="#" 
                    v-on:click.prevent="changeSelectedFlag('en-US')"
                    v-show="this.$store.state.active_US"
                    >
                        <i class="ico-flag-us flag-icon"></i>
                </b-dropdown-item>
                <b-dropdown-item 
                    href="#" 
                    v-on:click.prevent="changeSelectedFlag('es-ES')" 
                    v-show="this.$store.state.active_ES"
                    >
                        <i class="ico-flag-es flag-icon"></i>
                </b-dropdown-item>
        </b-dropdown>
    </div>
</template>
<script>
    import {  BDropdown , BDropdownItem } from 'bootstrap-vue'    
    export default {
        name : 'DropdownLocalization',      
        components: { 'b-dropdown' : BDropdown, 'b-dropdown-item' : BDropdownItem },          
        methods : {
            changeSelectedFlag: function (languageSelected, initialLoading) { 
                this.$store.commit("CHANGE_IN_TRANSLATION", true);
                let flagClassName           
                if(languageSelected === "en-US"){
                    this.$i18n.locale = 'en-US';
                    flagClassName = "ico-flag-us flag-icon"
                }                
                else if(languageSelected === "es-ES"){
                    this.$i18n.locale = 'es-ES';
                    flagClassName = "ico-flag-es flag-icon"
                }
                else{
                    this.$i18n.locale = 'pt-BR';
                    flagClassName = "ico-flag-br flag-icon"
                }
                this.$store.commit("CHANGE_LOCALIZATION", languageSelected);
                document.getElementById("iconFlag").children[0].className.baseVal = flagClassName;
                window.bsml.convertIcons();               
                this.loadMessages(languageSelected);

                if(!initialLoading)
                    this.sendMessageCultureChanged(languageSelected);
            },
            sendMessageCultureChanged : function(languageSelected){
                window.parent.postMessage({
                    'func': 'message',
                        'message': languageSelected
                    }, "*");
            },
            loadMessages : function(lang){
                var self = this;
                this.$http.get(`translations?origin=${this.$store.state.origin}&lang=${lang}`)
                    .then(response => {    
                        const lowerCaseObj = Object.fromEntries(
                            Object.entries(response.data).map(([k, v]) => [k.toLowerCase(), v])
                        );                              
                        self.$i18n.mergeLocaleMessage(lang, lowerCaseObj)

                        this.$store.commit("CHANGE_IN_TRANSLATION", false);
                        
                    });
            }
        },
        mounted () {
            window.bsml.convertIcons(); 
            this.changeSelectedFlag(this.$store.state.localization,true)
        }
    }
</script>